import { render, staticRenderFns } from "./MobileOS.vue?vue&type=template&id=183b2cc5&"
import script from "./MobileOS.vue?vue&type=script&lang=js&"
export * from "./MobileOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports